import { render, staticRenderFns } from "./InvN_Delivery.vue?vue&type=template&id=35e8b3db"
import script from "./InvN_Delivery.vue?vue&type=script&lang=js"
export * from "./InvN_Delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports